import React from 'react';
import { connect } from 'react-redux';
import { resendPin } from '../../../redux/userAuthentication/userAuth.actions';
import { setErrorPanel } from '../../../redux/utilities/utils.actions';
import { isValidLoginId } from '../../../utils/commonFunctions';

const ForgotPin = ({ resendPinText, resendPin, loginId, setErrorPanel }) => {
	const resendPinVerify = () => {
		if (!!loginId) {
			resendPin();
		} else {
			let panelMsg = isValidLoginId(loginId);

			if (panelMsg.length > 0) {
				setErrorPanel({
					panelClass: 'alert alert-danger',
					panelMsg,
				});
			}
		}
	};

	return (
		<span>
			<span
				className="pull-right email_phone_pin divAsAnchor"
				title={resendPinText}
				id="need_a_pin"
				data-toggle="modal"
				onClick={resendPinVerify}
			>
				{resendPinText}
			</span>
			<br />
		</span>
	);
};

const mapDispatchToProps = (dispatch) => {
	return {
		resendPin: () => dispatch(resendPin()),
		setErrorPanel: (val) => dispatch(setErrorPanel(val)),
	};
};

const mapStateToProps = (state) => {
	return {
		loginId: state.rootReducer.loginDetails.loginId,
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPin);
